export enum DataTheme {
  NONE = 'NONE',
  ICE_AGE = 'ICE_AGE',
  CLIMATE = 'CLIMATE',
  ENERGY = 'ENERGY',
  ENVIRONMENT = 'ENVIRONMENT'
}

export enum LayerViewType {
  NONE = 'NONE',
  INFO = 'INFO',
  OPACITY = 'OPACITY',
  SETTINGS = 'SETTINGS'
}

export enum ToolType {
  NONE = 'NONE',
  INFO = 'INFO',
  PROFILE = 'PROFILE',
  VIRTUAL_BOREHOLE = 'VIRTUAL_BOREHOLE',
  _3D_VIEW = '3D_VIEW'
}
